const classNames = (obj: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: boolean | string | number | null | undefined | any;
   
}, fixedClass: string = '') => {
    const classes: string[] = [];

    for (const key in obj) {
        if (obj[key] === '' || Boolean(obj[key])) {
            classes.push(key);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    fixedClass && (fixedClass = fixedClass + ' ');
    return fixedClass + classes.join(' ');
};

export { classNames };
